<template>
  <div class="parlor-detail-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner">

    </div>

    <!-- 详情内容部分 -->
    <div class="detail-container">
      <div class="detail-wrapper">
        <!-- 左侧主要内容 -->
        <div class="detail-main">
          <div class="detail-card">
            <h2 class="detail-title">{{ activityDetail.title || '' }}</h2>
            <div class="detail-date">{{ activityDetail.createTime || '' }}</div>
            <div class="detail-content" v-html="activityDetail.description || ''"></div>
          </div>
        </div>

        <!-- 右侧活动信息 -->
        <div class="detail-sidebar">
          <div class="sidebar-card">
            <!-- 移除箭头 -->

            <!-- 添加报名按钮到顶部 -->
            <div class="signup-action">
              <div class="signup-btn" @click="handleSignup">
                <span class="signup-text">点击报名</span>
                <div class="signup-arrow">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon security-icon">
                <i class="el-icon-medal-1"></i>
              </div>
              <div class="info-content">
                <div class="info-label">活动主题</div>
                <div class="info-value">{{ activityDetail.subtitle || '' }}</div>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon location-icon">
                <i class="el-icon-house"></i>
              </div>
              <div class="info-content">
                <div class="info-label">活动地点</div>
                <div class="info-value">{{ activityDetail.address || '' }}</div>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon time-icon">
                <i class="el-icon-time"></i>
              </div>
              <div class="info-content">
                <div class="info-label">活动时间</div>
                <div class="info-value">{{ activityDetail.activityTime || '' }}</div>
              </div>
            </div>

            <!-- 移除底部的报名按钮 -->
          </div>
        </div>
      </div>
    </div>

    <!-- 报名弹窗 -->
    <el-dialog
      title="报名信息"
      :visible.sync="enrollForm.visible"
      width="400px"
      :close-on-click-modal="false"
      center
    >
      <div class="enroll-form">
        <div class="form-item">
          <input type="text" v-model="enrollForm.name" placeholder="您的姓名" class="form-input">
        </div>
        <div class="form-item">
          <input type="text" v-model="enrollForm.mobile" placeholder="手机号码" class="form-input">
        </div>
        <div class="form-item">
          <input type="text" v-model="enrollForm.company" placeholder="公司名称" class="form-input">
        </div>
        <div class="form-item">
          <el-cascader
            v-model="enrollForm.regionArray"
            :options="areaOptions"
            :props="areaProps"
            placeholder="所在地区"
            clearable
            class="form-cascader"
            @change="handleAreaChange">
          </el-cascader>
        </div>
        <div class="form-submit">
          <button class="submit-btn" @click="submitEnroll">提 交</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getIndustryLoungeDetailApi, userEnrollApi, areaListApi } from '@/api/index';

export default {
  name: 'parlorDetail',
  data() {
    return {
      activityDetail: {},
      loading: false,
      id: null,
      enrollForm: {
        visible: false,
        name: '',
        mobile: '',
        company: '',
        loungeId: '',
        region: '', // 最终提交的地区编码值
        regionArray: [] // 级联选择器绑定值
      },
      areaOptions: [], // 地区选项
      areaProps: {
        value: 'code',
        label: 'label',
        children: 'children',
        checkStrictly: false, // 允许选择任何一级
      },
      defaultContent: `
        <p>这是内容详情,提供活动的详细描述和说明。这是内容详情,提供活动的详细描述和说明。这是内容详情,提供活动的详细描述和说明。这是内容详情,提供活动的详细描述和说明。这是内容详情,提供活动的详细描述和说明。这是内容详情,提供活动的详细描述和说明。这是内容详情,提供活动的详细描述和说明。这是内容详情,提供活动的详细描述和说明。</p>

        <p>Cras non ultricies sapien, eu viverra dui. Vivamus at rutrum ex, in blandit nibh. Nullam sit amet rutrum lacus. Pellentesque elementum, ante at ullamcorper fermentum, felis quam ultrices eros, eu lacinia libero ligula varius nibh. Ut vel eros et nulla maximus risus sit ac ligula.</p>

        <p>Suspendisse pretend. Sed diam purus est, eget vel elit Mauris gravida non in eu libero faucet fringilla quam sit amet magna pretium, eu scelerisque felis ultrices. Curabitur posuere aliquet et libero condimentum tempus. Praesent in blandit ex. Curabitur dignissim, ligula at tincidunt auctor, turpis massa dictum magna, sollicitudin sagittis est quam ac diam.</p>

        <div style="display: flex; justify-content: space-between; margin: 20px 0;">
          <div style="width: 48%; background-color: #f0f0f0; height: 200px;"></div>
          <div style="width: 48%; background-color: #f0f0f0; height: 200px;"></div>
        </div>

        <p>Morbi non mattis vitae turpis condimentum suscipit. Mauris bibendum, ligula a commodo dignissim, mauris justo malesuada nisl, at cursus risus nisi eget nisi. Mauris sit amet sem placerat, elementum enim nulla, finibus lacus.</p>

        <p>Nam mauris erat, finibus id feugiat vitae, lobortis ut arcu. Phasellus et dui fermentum, elementum felis, Fusce mauris pharetra arcu, vehicula velit. In nisi habitasse platea dictumst. Quisque egestas tellus vel efficitur cursus. Quisque vulputate aliquet faucibus. Vestibulum placerat bibendum facilisis.</p>
      `,
    }
  },
  created() {
    // 从路由获取活动ID
    this.id = this.$route.params.id;
    if (this.id) {
      this.getActivityDetail();
    }
    // 获取地区数据
    this.getAreaList();
  },
  methods: {
    async getActivityDetail() {
      try {
        this.loading = true;
        const res = await getIndustryLoungeDetailApi(this.id);
        if (res && res.data) {
          this.activityDetail = res.data;
        } else {
          this.$message.error('获取活动详情失败');
        }
      } catch (error) {
        console.error('获取活动详情出错', error);
        this.$message.error('获取活动详情失败');
      } finally {
        this.loading = false;
      }
    },

    // 获取地区列表数据
    async getAreaList() {
      try {
        const res = await areaListApi();
        if (res && res.data) {
          // 过滤掉level=3的数据，只保留省市两级
          const filteredData = res.data.map(province => {
            // 深拷贝省级数据
            const provinceCopy = JSON.parse(JSON.stringify(province));

            // 处理市级数据，移除区县级
            if (provinceCopy.children && provinceCopy.children.length > 0) {
              provinceCopy.children = provinceCopy.children.map(city => {
                // 移除区县级数据
                const cityCopy = JSON.parse(JSON.stringify(city));
                delete cityCopy.children;
                return cityCopy;
              });
            }

            return provinceCopy;
          });

          this.areaOptions = filteredData;
        } else {
          this.$message.error('获取地区列表失败');
        }
      } catch (error) {
        console.error('获取地区列表出错', error);
        this.$message.error('获取地区列表出错');
      }
    },

    // 地区选择变化处理
    handleAreaChange(value) {
      if (value && value.length > 0) {
        // 使用选中的code作为最终提交的地区编码
        this.enrollForm.region = value[value.length - 1];
      } else {
        this.enrollForm.region = '';
      }
    },
    
    // 处理报名点击
    handleSignup() {
      this.enrollForm.loungeId = this.id;
      this.enrollForm.visible = true;
    },
    
    // 提交报名
    async submitEnroll() {
      // 表单验证
      if (!this.enrollForm.name || this.enrollForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      
      if (!this.enrollForm.mobile || this.enrollForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      
      if (!/^1[3-9]\d{9}$/.test(this.enrollForm.mobile)) {
        this.$message.error('请输入正确的手机号码');
        return;
      }
      
      if (!this.enrollForm.company || this.enrollForm.company.trim() === '') {
        this.$message.error('请输入公司名称');
        return;
      }
      
      try {
        const enrollData = {
          name: this.enrollForm.name,
          mobile: this.enrollForm.mobile,
          company: this.enrollForm.company,
          loungeId: this.enrollForm.loungeId,
          region: this.enrollForm.region // 添加地区编码
        };
        
        const res = await userEnrollApi(enrollData);
        this.$message({
          type: 'success',
          message: '报名成功，我们会尽快与您联系'
        });
        
        // 关闭弹窗并重置表单
        this.enrollForm.visible = false;
        this.resetForm();
      } catch (error) {
        console.error('报名失败', error);
        this.$message.error('报名失败，请稍后重试');
      }
    },

    // 重置表单
    resetForm() {
      this.enrollForm.name = '';
      this.enrollForm.mobile = '';
      this.enrollForm.company = '';
      this.enrollForm.regionArray = [];
      this.enrollForm.region = '';
    }
  }
}
</script>

<style scoped lang="scss">
.parlor-detail-page {
  width: 100%;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 400px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/news-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  color: #fff;

  .content {
    width: 1200px;
    margin: 0 auto;

    h1 {
      font-weight: bold;
      font-size: 48px;
      line-height: 60px;
      margin-bottom: 20px;
    }
  }
}

// 详情内容
.detail-container {
  width: 1200px;
  margin: -80px auto 60px;
  position: relative;

  .detail-wrapper {
    display: flex;
    justify-content: space-between;

    .detail-main {
      width: 850px;

      .detail-card {
        background-color: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        padding: 40px;
        border-radius: 4px;

        .detail-title {
          font-weight: bold;
          font-size: 28px;
          color: #333;
          text-align: center;
          margin-bottom: 20px;
        }

        .detail-date {
          font-size: 14px;
          color: #999;
          text-align: center;
          margin-bottom: 40px;
        }

        .detail-content {
          font-size: 16px;
          line-height: 1.8;
          color: #333;

          p {
            margin-bottom: 20px;
          }
        }
      }
    }

    .detail-sidebar {
      width: 320px;
      margin-top: 130px;

      .sidebar-card {
        background-color: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        padding: 20px;
        border-radius: 4px;
        position: relative;

        // 删除point-to-detail样式

        .info-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 25px;
          padding-bottom: 15px;
          border-bottom: 1px solid #f5f5f5;

          &:last-of-type {
            border-bottom: none;
          }

          .info-icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 15px;
            border: 1px solid #e0e0e0;

            i {
              font-size: 24px;
              color: #333;
            }

            &.security-icon {
              border: 1px solid #e0e0e0;
            }

            &.location-icon {
              border: 1px solid #e0e0e0;
            }

            &.time-icon {
              border: 1px solid #e0e0e0;
            }
          }

          .info-content {
            flex: 1;
            padding-top: 5px;

            .info-label {
              font-weight: bold;
              font-size: 14px;
              color: #19456B;
              line-height: 24px;
            }

            .info-value {
              font-weight: 400;
              font-size: 14px;
              color: #382933;
              line-height: 24px;
            }
          }
        }

        // 报名按钮样式
        .signup-action {
          margin-bottom: 25px;

          .signup-btn {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 50px;
            background-color: #fff;
            border: 1px solid #eee;
            border-radius: 4px;
            cursor: pointer;
            box-shadow: 0 2px 6px rgba(0,0,0,0.05);

            .signup-text {
              padding-left: 20px;
              font-size: 16px;
              font-weight: 500;
              color: #333;
            }

            .signup-arrow {
              background-color: #00008E;
              color: #fff;
              width: 70px;
              height: 50px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;

              i {
                font-size: 24px;
              }
            }

            &:hover {
              box-shadow: 0 4px 10px rgba(0,0,0,0.1);
            }
          }
        }
      }
    }
  }
}

// 报名弹窗样式
::v-deep .el-dialog {
  border-radius: 8px;
  overflow: hidden;

  .el-dialog__header {
    padding: 20px 0;
    text-align: center;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }
  }

  .el-dialog__body {
    padding: 20px 30px;
  }
}

.enroll-form {
  .form-item {
    margin-bottom: 15px;
    
    .form-input {
      width: 100%;
      height: 50px;
      line-height: 50px;
      border: 1px solid #E0E0E0;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      font-size: 16px;
      outline: none;
      
      &:focus {
        border-color: #00008E;
      }
      
      &::placeholder {
        color: #999;
      }
    }
    
    // 添加级联选择器样式
    .form-cascader {
      width: 100%;
      
      ::v-deep .el-input__inner {
        height: 50px;
        line-height: 50px;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;
        font-size: 16px;
      }
    }
  }

  .form-submit {
    margin-top: 20px;

    .submit-btn {
      width: 100%;
      height: 50px;
      background-color: #FFC107;
      color: #000;
      border: none;
      border-radius: 25px;
      font-size: 18px;
      font-weight: 500;
      cursor: pointer;
      outline: none;

      &:hover {
        background-color: #FFCA28;
      }
    }
  }
}
</style>